module.exports = __webpack_public_path__ + "static/media/tab-checkin.f304676b.svg";